import { yupResolver as baseYupResolver } from '@hookform/resolvers/yup'
import type { Resolver, FieldValues } from 'react-hook-form'
import type { ObjectSchema, InferType } from 'yup'

/**
 * yup v1 + @hookform/resolvers v5 の型互換性ラッパー
 *
 * yup v1 の ObjectSchema では Input 型（required keys with `| undefined`）と
 * Output 型（optional keys `?:`）が異なるため、useForm の型推論と
 * FormField/Controller の control 型が不一致になる。
 * このラッパーで InferType<S> に統一することで型の一貫性を保つ。
 */
export function yupResolver<S extends ObjectSchema<FieldValues>>(
  schema: S,
  schemaOptions?: Parameters<typeof baseYupResolver>[1],
): Resolver<InferType<S>> {
  return baseYupResolver(schema, schemaOptions) as Resolver<InferType<S>>
}
